export const convertToDateObject = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    hour: date.getHours(),
    minute: date.getMinutes(),
    second: date.getSeconds(),
  };
};

export const sortByDate = (array, type) => {
  return [...array].sort((a, b) => {
    const dateA = new Date(type === 'ended' ? a.End : a.Begin).toISOString();
    const dateB = new Date(type === 'ended' ? b.End : b.Begin).toISOString();

    if (!dateA) return 1;
    if (!dateB) return -1;

    return dateB.localeCompare(dateA);
  });
};

export const formatDate = (date, includeTime = false) => {
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...(includeTime && { hour: '2-digit', minute: '2-digit' }),
  };

  return new Date(date).toLocaleString('sv-SE', options);
};

export const formatDateRange = (start, end) => {
  const startDate = new Date(start);
  const formattedStartDate = formatDate(start, false);
  const formattedStartDateWithTime = formatDate(start, true);

  if (!end) return formattedStartDateWithTime;

  const endDate = new Date(end);
  const formattedEndDateWithTime = formatDate(end, true);

  if (startDate.toDateString() === endDate.toDateString()) {
    return `${formattedStartDate} ${startDate
      .toTimeString()
      .substring(0, 5)} – ${endDate.toTimeString().substring(0, 5)}`;
  } else {
    return `${formattedStartDateWithTime} – ${formattedEndDateWithTime}`;
  }
};

export const formatDateWithoutYear = (date) => {
  if (!date) return null;
  const options = { day: 'numeric', month: 'long' };
  return new Date(date).toLocaleDateString('sv-SE', options);
};
